import { FileDownloadProps, useGA4Tracking } from '@hooks/useGA4Tracking';
import DownloadIcon from '@img/icons/download-with-line.svg';
import React from 'react';
import { ProductDocumentsStyles as S } from './ProductDocuments.styles';

interface ProductDocuments {
  title: string | undefined | null;
  documents: ({ name: string } & FileDownloadProps)[];
}

export interface ProductDocumentsProps {
  documents: ProductDocuments[];
}

const ProductDocuments: React.FC<ProductDocumentsProps> = ({ documents }) => {
  const { fileDownload } = useGA4Tracking();

  return (
    <S.Container>
      {documents.map((section) => (
        <>
          {section.title && <S.Title>{section.title}</S.Title>}
          <S.Documents>
            {section.documents.map((document) => (
              <S.DocumentWrapper
                key={document.linkUrl}
                href={document.linkUrl}
                download
                rel="noreferrer"
                target="_blank"
                onClick={() => {
                  fileDownload(document);
                }}
              >
                <S.DownloadItem>
                  <S.DownloadIcon>
                    <DownloadIcon />
                  </S.DownloadIcon>
                  <S.DocumentName>{document.name}</S.DocumentName>
                </S.DownloadItem>
              </S.DocumentWrapper>
            ))}
          </S.Documents>
        </>
      ))}
    </S.Container>
  );
};

export default ProductDocuments;
